// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + "56dc4e11" + ".chunk.css");